import { Button, ButtonEllipse, Tabs, tokens } from '@arvoreeducacao/bonsai-ds'
import styled from 'styled-components'
import { Cdn } from 'utils/assets'

export const BackButton = styled(ButtonEllipse)`
  display: none;

  @media only screen and (min-width: ${tokens.breakpoints.desktop}px) {
    display: block;
    position: absolute;
    top: 62px;
    margin: ${tokens.spacing.verticalMedium} ${tokens.spacing.horizontalMedium};
    z-index: 1;
    left: 22px;
  }

  @media only screen and (max-width: ${tokens.breakpoints.desktopLarge}px) {
    left: 60px;
  }

  @media only screen and (min-width: ${tokens.breakpoints.desktopXlarge}px) {
    left: 184px;
  }
`

export const Container = styled.div`
  width: 100vw;

  padding-top: ${tokens.spacing.insetXxlarge};

  position: relative;
  left: 50%;
  transform: translateX(-50%) translateY(-40px);

  @media only screen and (min-width: ${tokens.breakpoints.desktop}px) {
    background-image: url(${Cdn.getImageUrl('background.png')});
    background-size: contain;
    background-position: top;
    background-repeat: no-repeat;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    min-height: 100vh;
  }
`

export const Wrapper = styled.div`
  width: 100%;
  background: ${tokens.colors.white};
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 ${tokens.spacing.horizontalMedium} ${tokens.spacing.verticalMedium};
  border-radius: ${tokens.radius.radius_20}px;

  @media only screen and (min-width: ${tokens.breakpoints.desktop}px) {
    margin: ${tokens.spacing.verticalXxlarge} auto 0;
    max-width: 800px;
    padding: ${tokens.spacing.horizontalXlarge};
    box-shadow: ${tokens.shadows.centerLarge};
  }
`

export const MyAccessWrapper = styled.div`
  display: none;

  @media only screen and (min-width: ${tokens.breakpoints.desktop}px) {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: ${tokens.spacing.horizontalMedium};
    margin-bottom: ${tokens.spacing.verticalLarge};

    p {
      font-size: ${tokens.fontSize.small};
      font-weight: ${tokens.fontWeights.regular};
      line-height: ${tokens.lineHeight.medium}%;
      color: ${tokens.colors.dark5};
      margin: 0;
    }

    h4 {
      display: block;
      font-size: ${tokens.fontSize.large};
      font-weight: ${tokens.fontWeights.bold};
      line-height: ${tokens.lineHeight.medium}%;
      color: ${tokens.colors.dark6};
      margin: 0 0 ${tokens.spacing.verticalSmall} 0;
    }
  }
`

export const AccessCodeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: ${tokens.spacing.horizontalMedium};
  text-align: center;

  border-radius: ${tokens.radius.radius_20}px;
  border: solid 1px ${tokens.colors.livrosMedium};
  background-color: ${tokens.colors.livrosLight};

  p {
    font-size: ${tokens.fontSize.small};
    font-weight: ${tokens.fontWeights.bold};
    line-height: ${tokens.lineHeight.medium}%;
    color: ${tokens.colors.dark5};
    margin-top: 0;
  }

  > span {
    font-size: ${tokens.fontSize.xxxlarge};
    font-weight: ${tokens.fontWeights.bold};
    line-height: ${tokens.lineHeight.medium}%;
    color: ${tokens.colors.dark6};
  }
`

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 328px;
  padding: 0;
  margin: 0 auto;
`

export const MyAccessCodeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: ${tokens.spacing.horizontalMedium};
  margin-bottom: ${tokens.spacing.verticalMedium};

  p {
    font-size: ${tokens.fontSize.small};
    font-weight: ${tokens.fontWeights.regular};
    line-height: ${tokens.lineHeight.medium}%;
    color: ${tokens.colors.dark5};
    margin: 0;
  }

  h4 {
    display: none;
  }

  @media only screen and (min-width: ${tokens.breakpoints.desktop}px) {
    h4 {
      display: block;
      font-size: ${tokens.fontSize.large};
      font-weight: ${tokens.fontWeights.bold};
      line-height: ${tokens.lineHeight.medium}%;
      color: ${tokens.colors.dark6};
      margin: 0 0 ${tokens.spacing.verticalSmall} 0;
    }
  }
`

export const AccessCodeButton = styled(Button)`
  margin: ${tokens.spacing.verticalMedium} 0 ${tokens.spacing.verticalXsmall};
`

export const ForgotPassWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${tokens.spacing.verticalMedium};

  p {
    font-size: ${tokens.fontSize.small};
    font-weight: ${tokens.fontWeights.bold};
    line-height: ${tokens.lineHeight.medium}%;
    color: ${tokens.colors.dark5};
    text-align: center;
  }

  button {
    margin: 0 auto;
  }
`

export const MyAccessUserName = styled.h1`
  font-size: ${tokens.fontSize.xxlarge};
  font-weight: ${tokens.fontWeights.bold};
  line-height: ${tokens.lineHeight.medium}%;
  color: ${tokens.colors.dark6};
  margin: 0;

  @media only screen and (max-width: ${tokens.breakpoints.desktop}px) {
    display: none;
  }
`

export const MyAccessUserRoot = styled.p`
  font-size: ${tokens.fontSize.medium};
  font-weight: ${tokens.fontWeights.regular};
  line-height: ${tokens.lineHeight.medium}%;
  color: ${tokens.colors.dark5};
  margin: 0 0 ${tokens.spacing.verticalXxlarge} 0;

  @media only screen and (max-width: ${tokens.breakpoints.desktop}px) {
    display: none;
  }
`

export const CustomTabs = styled(Tabs)`
  margin-top: ${tokens.spacing.verticalXxlarge};

  @media only screen and (max-width: ${tokens.breakpoints.desktop}px) {
    display: none;
  }
`

export const Canvas = styled.canvas`
  position: absolute;
  display: none;
`
